export default __webpack_public_path__ + "static/media/pageHeader.a241a11a.jpg";